import React from 'react';
import styled from 'styled-components';
import { PageSlice, SliceTwoColProducts, SliceTwoColProductsItem } from '@contracts';

interface FeaturesProps {
  $icon_url: string;
}

interface Props {
  slice: PageSlice;
}

const TwoColProducts: React.FC<Props> = ({ slice }) => {
  const sliceDetails = slice.primary as SliceTwoColProducts;
  const sliceItems = slice.items as SliceTwoColProductsItem[];
  const icon_url = sliceDetails.feature_icons.url;
  return (
    <TwoColProductsContainer>
      <Wrapper>
        <h2>{sliceDetails.heading.text}</h2>
        <TwoColContainer>
          <TwoCol>
            {sliceItems.map((item: any, index: number) => (
              <ProductFeatures key={index}>
                <img src={item.aux_image.url} alt={item.aux_image.alt} />
                <Overline>{item.overline}</Overline>
                <h4>{item.heading.text}</h4>
                <img src={item.image.url} alt={item.image.alt} />
                <Features $icon_url={icon_url}>
                  <div dangerouslySetInnerHTML={{ __html: item.features.html }} />
                </Features>
              </ProductFeatures>
            ))}
          </TwoCol>
        </TwoColContainer>
      </Wrapper>
    </TwoColProductsContainer>
  );
};

export default TwoColProducts;

const TwoColProductsContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;

  & h2 {
    font-family: 'Domaine';
    font-size: 3rem;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -1.28px;
    text-align: center;
    padding: 0 4rem;

    @media (max-width: 600px) {
      font-size: 2rem;
      padding: 0 2rem;
    }
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10rem 0rem;
`;

const TwoColContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow-x: auto;

  @media (max-width: 800px) {
    /* scrollbar-width: none;
    -ms-overflow-style: none; // hide scrollbar on IE

    &::-webkit-scrollbar {
      display: none; // hide scrollbar on Webkit browsers
    } */
    // TODO: ↑ The idea is to have a horizontal slider on mobile, commented out until I fix sliding on desktop without tap drag
  }
`;

const TwoCol = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: 10rem;
  margin-top: 5rem;

  & h4 {
    font-family: 'Domaine';
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 130%;
  }

  @media (max-width: 1000px) {
    column-gap: 2rem;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    row-gap: 3rem;
    margin-left: 2rem;
    margin-right: 2rem;
  }
`;

const ProductFeatures = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  align-items: center;
  justify-content: center;
  text-align: left;
  padding: 1rem;
  width: 50%;

  & > h4 {
    text-align: center;
    margin: 1rem;
  }

  & > p {
    margin: 0;
  }

  @media (max-width: 800px) {
    width: 65vw;
    justify-content: flex-start;
  }

  @media (max-width: 400px) {
    width: 85vw;
  }
`;

const Features = styled.div<FeaturesProps>`
  & > div {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    margin-top: 3rem;
    max-width: 26rem;
  }

  & > div > p {
    font-size: 0.8rem;
    font-weight: 700;
    margin: 0;
    display: flex;
  }

  & > div > p::before {
    content: '';
    background-image: url(${(props) => props.$icon_url});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    width: 1.2rem;
    height: 1rem;
    font-weight: 700;
    margin: 0 1rem;
    flex-shrink: 0;
    margin-top: 0.25rem;
  }

  @media (max-width: 800px) {
    & > div > p {
      font-size: 0.9rem;
    }

    & > div > p::before {
      width: 0.8rem;
      height: 0.85rem;
      margin: 0.18rem 0.5rem 0;
    }
  }
`;

const Overline = styled.div`
  font-family: 'BrownStd';
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`;
